import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { emptyValue, TypedFormBuilder } from '@assetaccountant/core/utils/typed-forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './confirmation-modal.component.html',
  standalone: false,
})
export class ConfirmationModalComponent implements OnInit {
  @Input() text = 'Are you sure?';
  @Input() title = 'Confirmation';
  @Input() confirmationInput = 'DELETE';
  @Input() confirmButtonLabel?: string;
  @Input() cancelButtonLabel?: string;
  @Input() showCancelButton = true;

  form = this.fb.group({
    confirmation: emptyValue<string>(),
  });

  constructor(
    public activeModal: NgbActiveModal,
    private fb: TypedFormBuilder,
  ) {}

  ngOnInit() {
    this.form.controls.confirmation.setValidators([confirmationValidator(this.confirmationInput)]);
  }

  confirm() {
    this.activeModal.close('OK');
  }
}

export function confirmationValidator(testValue: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return control.value !== testValue ? { unmatched: true } : null;
  };
}
